export default "__VITE_ASSET__6147f655__"